import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px = 'M5.56 3 11 8l-5.44 5Z';
const draw24px = 'M9.56,7,15,12,9.56,17Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TriangleRightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'triangleRight')) as IconWithRender;

TriangleRightIcon.displayName = 'TriangleRightIcon';
TriangleRightIcon.propTypes = Icon.propTypes;
TriangleRightIcon.renderIcon = (props) => <TriangleRightIcon {...props} />;
export default TriangleRightIcon;
